export const set   = (account) => ({ type: 'SET_ACCOUNT', payload: account });
export const unset = () => ({ type: 'UNSET_ACCOUNT' });

export default (dispatch) => {
	return {
        set: (account) => dispatch(set(account)),
        unset: ()   => dispatch(unset())
    }
};